import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/services/-47768.png'
import _imports_1 from '../assets/services/27449444.png'
import _imports_2 from '../assets/services/27588180.png'
import _imports_3 from '../assets/services/27588498.png'
import _imports_4 from '../assets/services/27445621.png'


const _hoisted_1 = { class: "flexX_center" }

import { nextTick } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServicesVie',
  setup(__props) {

document.addEventListener("scroll", function () {
  const slideInDiv = document.querySelector(".dingcang");
  if (slideInDiv) {
    const divPosition = slideInDiv.getBoundingClientRect().top;
    const screenPosition = window.innerHeight;

    if (divPosition < screenPosition) {
      slideInDiv.classList.add("active");
    }
  }
});
document.addEventListener("scroll", function () {
  const yunshuInDiv = document.querySelector(".yunshu");
  if (yunshuInDiv) {
    const yunshu1Position = yunshuInDiv.getBoundingClientRect().top;
    const yunshu2Position = window.innerHeight;

    if (yunshu1Position < yunshu2Position) {
      yunshuInDiv.classList.add("active");
    }
  }
});
document.addEventListener("scroll", function () {
  const yunshuInDiv = document.querySelector(".cangchu");
  if (yunshuInDiv) {
    const yunshu1Position = yunshuInDiv.getBoundingClientRect().top;
    const yunshu2Position = window.innerHeight;

    if (yunshu1Position < yunshu2Position) {
      yunshuInDiv.classList.add("active");
    }
  }
});
document.addEventListener("scroll", function () {
  const yunshuInDiv = document.querySelector(".duichang");
  if (yunshuInDiv) {
    const yunshu1Position = yunshuInDiv.getBoundingClientRect().top;
    const yunshu2Position = window.innerHeight;

    if (yunshu1Position < yunshu2Position) {
      yunshuInDiv.classList.add("active");
    }
  }
});
nextTick(() => {
  const OUR_SERVICEInDiv = document.querySelector(".OUR_SERVICE");
  const wmdfwInDiv = document.querySelector(".wmdfw");
  setTimeout(() => {
    if (OUR_SERVICEInDiv) {
      OUR_SERVICEInDiv.classList.add("hide");
    }
    if (wmdfwInDiv) {
      wmdfwInDiv.classList.add("hide");
    }
  }, 500);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"services flexY_start\" style=\"margin-bottom:200px;\" data-v-16223aad><div class=\"image flexY_start\" data-v-16223aad><div style=\"margin-top:150px;\" data-v-16223aad><div style=\"color:#ffffff;font-size:54px;word-wrap:break-word;\" data-v-16223aad> 服务介绍 </div><br data-v-16223aad><div style=\"font-size:18px;color:#ffffff;letter-spacing:3px;line-height:1.75;margin-top:40px;\" data-v-16223aad> 礼邦物流 提供快速且优质的货品运输报关服务 </div></div></div><div class=\"flexY_center\" style=\"margin:60px 0;\" data-v-16223aad><div class=\"OUR_SERVICE\" style=\"font-size:60px;color:#ebebf3;font-weight:700;\" data-v-16223aad> OUR SERVICE </div><div class=\"wmdfw\" style=\"font-size:40px;color:#000000;font-weight:600;margin-top:-40px;\" data-v-16223aad> 我们的服务 </div><div style=\"background-color:rgb(19, 100, 233);height:7px;width:80px;margin-top:30px;\" data-v-16223aad></div></div><div class=\"serviceItems-1\" style=\"width:100%;\" data-v-16223aad><div class=\"serviceItem dingcang\" style=\"background-color:rgb(159, 196, 242);\" data-v-16223aad><div class=\"txt1\" data-v-16223aad><img src=\"" + _imports_0 + "\" data-v-16223aad></div><div class=\"txt2\" data-v-16223aad>订舱</div><div class=\"txt3\" data-v-16223aad> 公司秉承以人为本、追求超越的经营理念 恪守诚信为本、客户至尊为服务宗旨 </div></div><div class=\"serviceItem\" style=\"background-color:rgb(128, 178, 238);\" data-v-16223aad><div class=\"txt1\" data-v-16223aad><img src=\"" + _imports_1 + "\" data-v-16223aad></div><div class=\"txt2\" data-v-16223aad>报关</div><div class=\"txt3\" data-v-16223aad>我们提供快速报关功能，一体化服务</div></div><div class=\"serviceItem yunshu\" style=\"background-color:rgb(96, 158, 233);\" data-v-16223aad><div class=\"txt1\" data-v-16223aad><img src=\"" + _imports_2 + "\" data-v-16223aad></div><div class=\"txt2\" data-v-16223aad>运输</div><div class=\"txt3\" data-v-16223aad> 我们提供7x24小时的全天候响应速度 随时随地为您服务 </div></div></div><div class=\"serviceItems-2\" style=\"width:100%;margin-top:5px;\" data-v-16223aad><div class=\"serviceItem cangchu\" style=\"background-color:rgb(159, 196, 242);\" data-v-16223aad><div class=\"txt1\" data-v-16223aad><img src=\"" + _imports_3 + "\" data-v-16223aad></div><div class=\"txt2\" data-v-16223aad>仓储</div><div class=\"txt3\" data-v-16223aad>我们提供优质的储存服务，保障货物存取无忧</div></div><div class=\"serviceItem duichang\" style=\"background-color:rgb(128, 178, 238);\" data-v-16223aad><div class=\"txt1\" data-v-16223aad><img src=\"" + _imports_4 + "\" data-v-16223aad></div><div class=\"txt2\" data-v-16223aad>堆场</div><div class=\"txt3\" data-v-16223aad> 通过坚持不懈地开拓创新、与时俱进 公司不断开创新局面、实现新跨越 </div></div></div><div class=\"serviceItems-3\" style=\"width:100%;margin-top:5px;\" data-v-16223aad><div class=\"serviceItem\" style=\"background-color:rgb(249, 250, 252);\" data-v-16223aad><div class=\"txt1 flexX_center\" data-v-16223aad><i class=\"reppon-icon icon-hezi iconStyle\" data-v-16223aad></i></div><div class=\"txt2\" style=\"font-weight:500;\" data-v-16223aad>线上下单</div><div class=\"txt3\" data-v-16223aad>线上下单，快速便捷</div></div><div class=\"serviceItem\" style=\"background-color:rgb(249, 250, 252);\" data-v-16223aad><div class=\"txt1 flexX_center\" data-v-16223aad><i class=\"reppon-icon icon-wode-gengduodingdan iconStyle\" data-v-16223aad></i></div><div class=\"txt2\" data-v-16223aad>查询订单</div><div class=\"txt3\" data-v-16223aad>订单状态随时可查随时</div></div><div class=\"serviceItem\" style=\"background-color:rgb(249, 250, 252);\" data-v-16223aad><div class=\"txt1 flexX_center\" data-v-16223aad><i class=\"reppon-icon icon-huoche iconStyle\" data-v-16223aad></i></div><div class=\"txt2\" data-v-16223aad>预估送达时间</div><div class=\"txt3\" data-v-16223aad>提前预估运输时长，合理规划运输计划</div></div><div class=\"serviceItem\" style=\"background-color:rgb(249, 250, 252);\" data-v-16223aad><div class=\"txt1 flexX_center\" data-v-16223aad><i class=\"reppon-icon icon-jiesuan iconStyle\" data-v-16223aad></i></div><div class=\"txt2\" data-v-16223aad>费用结算</div><div class=\"txt3\" data-v-16223aad>费用自动结算，可线上快速对账</div></div></div></div>", 1)
  ])))
}
}

})